module.exports = __webpack_public_path__ + "img/third_tree.6606b72f.png";